import {processAudioSpeed} from './audioSpeed';
import {processAudioVolume,type AudioVolumeEffect} from './audioVolume';
/** One path for playback/export: preserve pitch first, then apply the envelope
 * over the final duration. Local authored silence bypasses both processors. */
export async function processAudioEffects(buffer:AudioBuffer,volume?:AudioVolumeEffect,speed?:number,signal?:AbortSignal){
  return processAudioVolume(await processAudioSpeed(buffer,speed,signal),volume);
}
